import React, { useEffect, useState, Fragment, useContext, useMemo } from "react";
import {
  Row,
  IconWrapper,
  HorizontalSeparator,
  IconBox,
  TextWrapper,
  LogoWrapper,
  BottomLogoWrapper,
  Text,
} from "../styled/Tooltip.styled";
import {
  SupplyType,
  TooltipType,
  bestTopTypeKeyMapper,
  bestOpTypeKeyMapper,
  supplyLvlMapper,
  formatSupplyLevel,
} from "../../constants/WebMap";
import TopTooltipInternal from "./TopTooltipInternal";
import InfoTooltipInternal from "./infoTooltipInternal";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";
import Divider from "@mui/material/Divider";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { LightTooltip } from "../styled/LightTooltip.styled";


export default function TopMSTooltip({
  supplyType,
  geohashStat,
  type = TooltipType.NORMAL,
  operator = null,
  topMarketShareToggle,
  permittedOperators
}) {
  const { operatorDetails = [], supplyStrengthLevels = {} } =
    useContext(WebMapContext);
  const [selectedOperator, setSelectedOperator] = useState(null);
  const [bestOperator, setBestOperator] = useState();
  const [otherOperators, setOtherOperators] = useState(null);
  const [customOperator, setCustomOperator] = useState(null);
  const [visibleContent, setVisibleContent] = useState(false);

  useEffect(() => {
    if (geohashStat && supplyType && type) {
      if (type === TooltipType.BEST) {
        let best_operator =
          geohashStat.data.best[bestTopTypeKeyMapper[supplyType]];
        let bestOperator = geohashStat.data.op.filter(
          (item) => item.op === best_operator
        );
        if (bestOperator.length > 0) {
          let operatorsExceptBestOperator = [];
          geohashStat.data.op.map((item) => {
            if (item.op !== bestOperator[0].op) {
              operatorsExceptBestOperator.push(item);
            }
            return null;
          });
          const oprtData = operatorDetails.find(
            (x) => x.operator === best_operator
          );
          if (!bestOperator[0].isAnonymized) {
            setBestOperator({ ...bestOperator[0], ...oprtData });
          } else { setBestOperator(bestOperator[0]) }
          operatorsExceptBestOperator = [
            ...new Set(
              operatorsExceptBestOperator.map((s) => JSON.stringify(s))
            ),
          ].map((s) => JSON.parse(s));
          const sorted = [...operatorsExceptBestOperator].sort((a, b) => a.op.localeCompare(b.op));
          setOtherOperators(sorted);
          setSelectedOperator(sorted[0]);
        } else {
          setBestOperator(null);
          const sorted = [...geohashStat.data.op].sort((a, b) => a.op.localeCompare(b.op));
          setOtherOperators(sorted);
          setSelectedOperator(sorted[0]);
        }
      } else {
        let best_operator =
          geohashStat.data.best[bestOpTypeKeyMapper[supplyType]];
        let bestOperator = geohashStat.data.op.filter(
          (item) => item.op === best_operator
        );
        const oprtData = permittedOperators.find(
          (x) => x.operator === best_operator
        );
        setBestOperator({ ...bestOperator[0], ...oprtData });
        const selectOp = geohashStat.data.op.filter(
          (item) => item.op === operator
        );
        const customOp = permittedOperators.find((x) => x.operator === operator);
        setCustomOperator({ ...selectOp[0], ...customOp });
      }
    }
  }, [supplyType, geohashStat, type]);

  const admNames = useMemo(() => {
    if (visibleContent) {
      return geohashStat?.lvls?.map((obj) => {
        const [key, value] = Object.entries(obj)[0];
        return { adm: key, name: value };
      });
    } else {
      const lastItm = geohashStat.lvls.slice(-1)[0];
      return [{ adm: Object.keys(lastItm)[0], name: Object.values(lastItm)[0] }]
    }
  }, [visibleContent, geohashStat]);

  const onClickOperator = (operator) => {
    setSelectedOperator(operator);
  };

  return (

    <Fragment>

      <div
        style={{
          minWidth: "200px",
          display: "flex",
          justifyContent: "center",

        }}
      >
        <div
          style={{
            minWidth: "200px",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",

          }}
        >
          {type === TooltipType.NORMAL && customOperator && (
            <Fragment>
              <Row
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <LogoWrapper align={"center"} width={"50px"} height={"25px"}>
                {customOperator.icon && !customOperator.isAnonymized
                  ?
                  <img
                    src={customOperator?.icon}
                    alt="logo1"
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                    height="auto"
                    vertical-align="middle"
                  />
                  : <h4 style={{
                    color: "#707070",
                    fontSize: "10px",
                    textAlign: "center",
                    lineHeight: "18px",
                    border: "1px solid #016F35",
                    borderRadius: "4px",
                    padding: "3px 5px",
                    display: "inline-block",
                    margin: "20px"
                  }}>{customOperator.name}</h4>}
                </LogoWrapper>
              </Row>
              <HorizontalSeparator />

              <TopTooltipInternal
                dbmValue={customOperator.avg_dbm}
                uploadValue={customOperator.avg_upload}
                downloadValue={customOperator.avg_download}
                rsrqValue={customOperator.rsrq}
                sinrValue={customOperator.sinr}
                supplyType={supplyType}
                rsrpLevel={customOperator.l_rsrp}
                downLevel={customOperator.l_down}
                upLevel={customOperator.l_up}
                rsrqLevel={customOperator.l_rsrq}
                sinrLevel={customOperator.l_sinr}
                ms={customOperator.ms}
                ms_rank={customOperator.ms_rank}
                action={customOperator.action}
                quad={customOperator.quad}
                dataReceived={customOperator.data_received}
                dataTransceived={customOperator.data_transceived}
                dataTransmitted={customOperator.data_transmitted}
                topMarketShareToggle={topMarketShareToggle}
                type={"customOperator"}
              />
              <HorizontalSeparator />
            </Fragment>
          )}
          {
            <Row style={{ height: "30px" }}>
              <IconWrapper>
                <img src={"/assets/bestoperator.png"} alt="logo1" width="13" />
              </IconWrapper>
              <div style={{ width: "110%", fontWeight: "900" }}>
                Best Operator
              </div>
              <LogoWrapper align={"flex-end"} width={"64px"} height={"30px"}>
                {bestOperator && bestOperator?.icon && !bestOperator?.isAnonymized ? (
                  <img
                    src={bestOperator?.icon}
                    alt="logo1"
                    style={{ maxWidth: "100%", maxHeight: "100%" }}
                    height="auto"
                    vertical-align="middle"
                  />
                ) : (
                  bestOperator?.name && (
                    <h4
                      style={{
                        color: "#707070",
                        fontSize: "10px",
                        textAlign: "center",
                        lineHeight: "18px",
                        border: "1px solid #016F35",
                        borderRadius: "4px",
                        padding: "4px 5px",
                        display: "inline-block",
                        margin: "20px",
                      }}
                    >
                      {bestOperator?.name}
                    </h4>
                  )
                )}
              </LogoWrapper>
            </Row>
          }
          {bestOperator ? (
            <Fragment>
              <HorizontalSeparator />
              <TopTooltipInternal
                dbmValue={bestOperator.avg_dbm}
                uploadValue={bestOperator.avg_upload}
                downloadValue={bestOperator.avg_download}
                rsrqValue={bestOperator.rsrq}
                sinrValue={bestOperator.sinr}
                supplyType={supplyType}
                rsrpLevel={bestOperator.l_rsrp}
                downLevel={bestOperator.l_down}
                upLevel={bestOperator.l_up}
                rsrqLevel={bestOperator.l_rsrq}
                sinrLevel={bestOperator.l_sinr}
                ms={bestOperator.ms}
                ms_rank={bestOperator.ms_rank}
                action={bestOperator.action}
                quad={bestOperator.quad}
                dataReceived={bestOperator.data_received}
                dataTransceived={bestOperator.data_transceived}
                dataTransmitted={bestOperator.data_transmitted}
                topMarketShareToggle={topMarketShareToggle}
                type={"bestOperator"}
              />
              {otherOperators && otherOperators.length > 0 && (
                <Fragment>
                  <HorizontalSeparator />
                  <Row
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      height: "30px",
                      alignItems: "center",
                      // flexWrap: "wrap",
                    }}
                  >
                    {otherOperators.map((item, index) => {
                      const oprt = operatorDetails.find((x) => x.operator === item.op);

                      return (
                        <Fragment key={index}>
                          <BottomLogoWrapper
                            isClicked={
                              item.op === selectedOperator.op ? true : false
                            }
                            onClick={() => {
                              onClickOperator(item);
                            }}
                            width={"60px"}
                            height={"30px"}
                          >

                          {!item.isAnonymized ? (
                            <img
                              src={oprt?.icon}
                              alt={oprt?.name}
                              style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain',
                              }}
                            />
                          ) : (
                            <h4 style={{
                              color: "#707070",
                              fontSize: "10px",
                              textAlign: "center",
                              lineHeight: "18px",
                              border: "1px solid #016F35",
                              borderRadius: "4px",
                              padding: "4px 5px",
                              display: "inline-block",
                              margin: "20px"
                            }}>{item?.name}</h4>
                          )}
                        </BottomLogoWrapper>
                        </Fragment>
                      );
                    })}
                  </Row>
                  <HorizontalSeparator />
                  {selectedOperator && (
                    <TopTooltipInternal
                      dbmValue={selectedOperator.avg_dbm}
                      uploadValue={selectedOperator.avg_upload}
                      downloadValue={selectedOperator.avg_download}
                      rsrqValue={selectedOperator.rsrq}
                      sinrValue={selectedOperator.sinr}
                      supplyType={supplyType}
                      rsrpLevel={selectedOperator.l_rsrp}
                      downLevel={selectedOperator.l_down}
                      upLevel={selectedOperator.l_up}
                      rsrqLevel={selectedOperator.l_rsrq}
                      sinrLevel={selectedOperator.l_sinr}
                      ms={selectedOperator.ms}
                      ms_rank={selectedOperator.ms_rank}
                      action={selectedOperator.action}
                      quad={selectedOperator.quad}
                      dataReceived={selectedOperator.data_received}
                      dataTransceived={selectedOperator.data_transceived}
                      dataTransmitted={selectedOperator.data_transmitted}
                      topMarketShareToggle={topMarketShareToggle}
                      type={"selectedOperator"}
                    />
                  )}
                </Fragment>
              )}
            </Fragment>
          ) : (
            <Fragment>
              <HorizontalSeparator />
              <TopTooltipInternal
                dbmValue={null}
                uploadValue={null}
                downloadValue={null}
                rsrqValue={null}
                sinrValue={null}
                dataReceived={null}
                dataTransceived={null}
                dataTransmitted={null}
                supplyType={supplyType}
              />
            </Fragment>
          )}
        </div>
        <Divider
          orientation="vertical"
          flexItem
          style={{ margin: "5px 20px", border: "1px dashed #dcd6d6", position: "sticky", top: 30 }}
        />
        <button
          style={{
            position: "sticky",
            top: "50%",
            transform: "translateY(-50%)",
            left: "50%",
            transform: "translateX(-50%)",
            fontSize: "16px",
            cursor: "pointer",
            borderRadius: "35%",
            padding: "9px 4px",
            border: "1px solid #dcd6d6",
            backgroundColor: "white",
            height: "40px",
            marginLeft: "-20px",
            marginRight: "-10px",
          }}
          onClick={() => {
            setVisibleContent(!visibleContent);
          }}
        >
          {visibleContent ? (
            <ArrowBackIosNewIcon style={{ fontSize: "12px" }} />
          ) : (
            <ArrowForwardIosIcon style={{ fontSize: "12px" }} />
          )}
        </button>
        {(visibleContent && geohashStat.data && geohashStat.data.ad_info) && (
          <div
            style={{
              minWidth: "200px",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <InfoTooltipInternal
             data={geohashStat.data.ad_info}
            topMarketShareToggle={topMarketShareToggle}
             />
          </div>
        )}

      </div>
      <HorizontalSeparator />
      <Row style={{ width: '100%', ...(admNames.length != 1 && { height: "35px" }) }}>
        {admNames.map(x => (
          <div
            style={{
              display: "flex",
              justifyContent: "center",

              width: "100%",
              marginLeft: "2px",
              marginRight: "2px",
            }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: "1px 0px",

              }}
            >
              <IconWrapper>
                <img
                  src={"/assets/mappin-dark.png"}
                  style={{ width: "13px", height: "13px" }}
                  alt="Icon"
                />
              </IconWrapper>
              <Text style={{ fontWeight: 900 }}>{x.adm}:</Text>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                ...(admNames.length === 3 && { maxWidth: "80px" }),


              }}
            >
              <TextWrapper
                isBold={false}
                style={{
                  overflow: "hidden",
                  whiteSpace: "normal",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: "3",
                  WebkitBoxOrient: "vertical",
                  maxHeight: "70px",


                }}
              >{x.name}</TextWrapper>
            </div>
          </div>
        ))}
      </Row>
    </Fragment>
  );
}
